export const FAQ_CATEGORY_INTERACTION_TYPE = 'cta: accordion';
export const FAQ_CATEGORY_COMPONENT_TYPE = 'Accordion';
export const COLLAPSED_ACCORDION_LABEL = 'collapse';
export const EXPANDED_ACCORDION_LABEL = 'expand';
